import { Facebook, GitHub, LinkedIn, Twitter } from "@mui/icons-material";
import colors from "../../Assets/Gene20Themes/LightTheme/base/colors";
// import colors from "../../../Assets/theme/base/colors";

const { socialMediaColors } = colors;

const socialMediaRoutes = [
  {
    name: "facebook",
    icon: <Facebook sx={{ color: socialMediaColors.facebook.main }} />,
    url: "https://www.facebook.com/wilfredr319n",
  },
  {
    name: "twitter",
    icon: <Twitter sx={{ color: socialMediaColors.twitter.main }} />,
    url: "https://twitter.com/wilfred_reign",
  },
  {
    name: "linkedin",
    icon: <LinkedIn sx={{ color: socialMediaColors.linkedin.main }} />,
    url: "https://www.linkedin.com/in/wilfred-reign-037702215/",
  },
  {
    name: "github",
    icon: <GitHub sx={{ color: socialMediaColors.github.main }} />,
    url: "https://github.com/R319N",
  },
];
export default socialMediaRoutes;
